"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Aws = void 0;
const sdk_1 = require("../sdk");
var Aws;
(function (Aws) {
    Aws.get = () => {
        const url = '/aws';
        return sdk_1.SDK.axios.get(url);
    };
    Aws.post = (data) => {
        const url = `/aws`;
        return sdk_1.SDK.axios.post(url, data);
    };
    Aws.enqueueAutoRule = (data) => {
        const url = `/aws/auto-rules`;
        return sdk_1.SDK.axios.post(url, data);
    };
    Aws.enqueueAppsSession = (data) => {
        const url = `/aws/app-rules`;
        return sdk_1.SDK.axios.post(url, data);
    };
})(Aws = exports.Aws || (exports.Aws = {}));
//# sourceMappingURL=aws.js.map